var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42907 5.86984C4.76881 5.63287 4.85211 5.16536 4.61514 4.82563C4.37817 4.48589 3.91066 4.40259 3.57093 4.63956L4.42907 5.86984ZM12.4291 4.63956C12.0893 4.40259 11.6218 4.48589 11.3849 4.82563C11.1479 5.16536 11.2312 5.63287 11.5709 5.86984L12.4291 4.63956ZM8.75 1C8.75 0.585786 8.41421 0.25 8 0.25C7.58579 0.25 7.25 0.585786 7.25 1H8.75ZM7.25 9C7.25 9.41421 7.58579 9.75 8 9.75C8.41421 9.75 8.75 9.41421 8.75 9H7.25ZM14.25 11C14.25 14.4518 11.4518 17.25 8 17.25V18.75C12.2802 18.75 15.75 15.2802 15.75 11H14.25ZM8 17.25C4.54822 17.25 1.75 14.4518 1.75 11H0.25C0.25 15.2802 3.71979 18.75 8 18.75V17.25ZM1.75 11C1.75 8.87677 2.80806 7.00053 4.42907 5.86984L3.57093 4.63956C1.56497 6.03876 0.25 8.36576 0.25 11H1.75ZM11.5709 5.86984C13.1919 7.00053 14.25 8.87677 14.25 11H15.75C15.75 8.36576 14.435 6.03876 12.4291 4.63956L11.5709 5.86984ZM7.25 1V9H8.75V1H7.25Z",
    fill: "#2AB7F8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2d8c1a89155d80978dbf2023c64f22f8.svg";
export { ForwardRef as ReactComponent };